import React from 'react';
import { SlateButton, SlateHeaderContainer, SlateHeaderInfo } from "./CrewBuilderElements"

const SlateHeader = ({ slate, handleSlateReset }) => {

    return (
        <>
            <SlateHeaderContainer>
                <SlateHeaderInfo>
                    {slate.Operator} {slate.OperatorName}
                </SlateHeaderInfo>
                <SlateButton onClick={handleSlateReset()}>Reset Slate</SlateButton>
            </SlateHeaderContainer>
        </>
    )
};

export default SlateHeader;